import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Form, Modal, Button } from 'react-bootstrap';
import { FaPlus, FaSortAmountUp, FaSortAmountDown, FaNewspaper, FaPlay, FaArrowLeft, FaArrowRight, FaEdit, FaHeart } from 'react-icons/fa';
import Navbar from '../dashboard/navbar';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import { format, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';
import axios from 'axios';
import StatutInternet from '../administration/statutInternet';
import timezones from 'timezones-list';


const Historique_examen = ({ titre }) => {
    useAuth();
    const [examen, setExamen] = useState([]);
    const [selectedExamen, setSelectedExamen] = useState(null);
    const [expandedDescriptions, setExpandedDescriptions] = useState({});
    const [sortConfig, setSortConfig] = useState({ key: 'date_demande', direction: 'descending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showModifierModal, setShowModifierModal] = useState(false);
    const [showModifierBootcampModal, setShowModifierBootcampModal] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [examenDescriptionOverflows, setExamenDescriptionOverflows] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });
    const stored = localStorage.getItem('heureFinExamen');
    const examen_id_strored = localStorage.getItem('examen_id_strored');
    const [showDemarageModal, setShowDemarageModal] = useState(false);
    const [pauseChoice, setPauseChoice] = useState("avecPause");

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const totalItems = examen.length;  // Si 'examen' contient tous les examens

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');
    const { id } = useParams(); // Suppose que 'id' est dans l'URL
    const navigate = useNavigate();

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Examen"; // Définit le titre de la page
        }
    }, [user_id]);


    const isAdmin = false;
    const produit = "ExamenBlanc";
    const produit_id = localStorage.getItem('produit_id');

    // Marquer toutes les notifications d'un formulaire comme vues
    const marquerToutesVues = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/marquer-toutes-vues/${produit_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    is_admin: isAdmin,  // Passer isAdmin dans le corps de la requête
                    produit: produit
                }),
            });

            if (!response.ok) {
                throw new Error('Erreur lors de la requête');
            }

            const data = await response.json();
            console.log('Toutes les notifications marquées comme vues :', data);
        } catch (error) {
            console.error('Erreur dans marquerToutesVu:', error);
        }
    };
    useEffect(() => {
        marquerToutesVues();
    }, []);

    // Fetching examens récupérer la liste des examens créer par un utilisateur
    const fetchExamen = async () => {
        setIsLoading(true)
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-examenblanc-utilisateur/${user_id}/`);
            const data = await response.json();
            if (response.ok) {
                setExamen(data);
                setIsLoading(false)
            } else {
                console.log('Erreur lors de la récupération des examens', data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoading(false)
        }
    };
    useEffect(() => {
        if (user_id) {
            fetchExamen();
        }
    }, [user_id]);

    // Handle alerts
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
            fetchExamen()
        }, 3000);
    };

    // Handle alerts modal
    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });

    };

    const handleRowClick = (examen) => {
        setSelectedExamen(examen);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setAlertModal({ message: '', type: '' });
    }
    const handleShowModal = () => setShowModal(true);


    const handleCloseModifierModal = () => {
        setShowModifierModal(false);
        setAlertModal({ message: '', type: '' });
    }


    const handleCloseModifierBootcampModal = () => {
        setShowModifierBootcampModal(false);
        setAlertModal({ message: '', type: '' });
    }


    // Initilisation de l'état
    const [newExamenblanc, setNewExamenblanc] = useState({
        date: '',
        heure_examen: '',
        date_examen: '',
        tag: '',
        type_examen: '',
        langue: '',
        nbre_heures: '',
        non_traite: false,
        code_essai: '', // Nouveau champ
        plage_debut: '', // Nouveau champ
        plage_fin: '' // Nouveau champ
    });

    const [examenblancDetails, setExamenblancDetails] = useState({
        date: '',
        heure_examen: '',
        date_examen: '',
        tag: '',
        type_examen: '',
        langue: '',
        nbre_heures: '',
        non_traite: false,
        code_essai: '', // Nouveau champ
        plage_debut: '', // Nouveau champ
        plage_fin: '' // Nouveau champ
    });

    // const handleNewExamenblancChange = (e) => {
    //     const { name, value, type, checked } = e.target;
    //     setNewExamenblanc((prevExamen) => ({
    //         ...prevExamen,
    //         [name]: type === 'checkbox' ? checked : value,
    //     }));
    // };

    const handleNewExamenblancChange = (e) => {
        const { name, value } = e.target;

        setNewExamenblanc((prev) => {
            let updatedExamen = { ...prev, [name]: value };

            // Fusionner la date et l'heure pour obtenir un format valide
            if (name === "date_examen" || name === "heure_examen") {
                const date = updatedExamen.date_examen || new Date().toISOString().split("T")[0]; // Valeur par défaut : aujourd'hui
                const time = updatedExamen.heure_examen || "00:00"; // Valeur par défaut : minuit
                updatedExamen["dateTime_examen"] = `${date}T${time}`;
            }

            return updatedExamen;
        });
    };



    const convertDateFormat = (dateString) => {
        if (!dateString) return '';
        // Si la date est déjà au format ISO, ne la reformatez pas
        if (dateString.includes("T")) return dateString;

        const [date, time] = dateString.split(' ');
        const [day, month, year] = date.split('/');
        return `${year}-${month}-${day}T${time}`;
    };


    // const handleExamenblancDetailsChange = (e) => {
    //     const { name, value, type, checked } = e.target;
    //     setExamenblancDetails((prevExamen) => ({
    //         ...prevExamen,
    //         [name]: type === 'checkbox' ? checked : value,
    //     }));
    // };


    const handleExamenblancDetailsChange = (e) => {
        const { name, value } = e.target;

        setExamenblancDetails((prev) => {
            let updatedExamen = { ...prev, [name]: value };

            // Fusionner la date et l'heure pour le champ complet
            if (name === "date_examen" || name === "heure_examen") {
                const date = updatedExamen.date_examen || new Date().toISOString().split("T")[0]; // Date actuelle si vide
                const time = updatedExamen.heure_examen || "00:00"; // Minuit par défaut
                updatedExamen["dateTime_examen"] = `${date}T${time}`;
            }

            return updatedExamen;
        });
    };


    // Convertir au bon format au moment de l'ouverture de la modal
    // useEffect(() => {
    //     if (examenblancDetails.date_examen) {
    //         setExamenblancDetails((prevDetails) => ({
    //             ...prevDetails,
    //             date_examen: convertDateFormat(examenblancDetails.date_examen)
    //         }));
    //     }
    // }, [showModifierModal]);


    // Fonction pour afficher la date au format français
    const formatDateToFrench = (dateString) => {
        if (!dateString) return '';
        const date = parseISO(dateString); // Convertir la chaîne ISO en objet Date
        return format(date, "dd/MM/yyyy HH:mm", { locale: fr }); // Formater la date
    };

    //metrre la date à jour
    const [currentDateTime, setCurrentDateTime] = useState(new Date().toISOString().substring(0, 16));

    // Mettre à jour `currentDateTime` au moment où le modal s'ouvre
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentDateTime(new Date().toISOString().substring(0, 16));
        }, 60000); // Optionnel : Met à jour toutes les minutes

        return () => clearInterval(interval); // Nettoyage à la fermeture du composant
    }, []);


    // l'Utilisateur crée un nouvel examen
    // const handleSubmitNewExamenblanc = async () => {
    //     // Vérification des champs obligatoires
    //     if (newExamenblanc.type_examen === 'Bootcamp' && !newExamenblanc.tag) {
    //         showAlertModal("Veuillez renseigner le tag du bootcamp !", 'danger');
    //         return;
    //     }
    //     if (newExamenblanc.type_examen !== 'Bootcamp') {
    //         if (!newExamenblanc.date_examen) {
    //             showAlertModal("Veuillez renseigner la date et l'heure de l'examen !", 'danger');
    //             return;
    //         }
    //         if (!newExamenblanc.type_examen) {
    //             showAlertModal("Veuillez renseigner le type d'examen !", 'danger');
    //             return;
    //         }
    //         if (newExamenblanc.type_examen === 'Bootcamp' && !newExamenblanc.tag) {
    //             showAlertModal("Veuillez renseigner le tag du bootcamp !", 'danger');
    //             return;
    //         }
    //         if (!newExamenblanc.langue) {
    //             showAlertModal("Veuillez renseigner la langue de l'examen !", 'danger');
    //             return;
    //         }
    //         if (!newExamenblanc.nbre_heures) {
    //             showAlertModal("Veuillez indiquer le nombre d'heures !", 'danger');
    //             return;
    //         }
    //     }

    //     setIsButtonLoading(true);

    //     // Récupération du fuseau horaire sélectionné ou du fuseau par défaut de l'utilisateur
    //     const selectedTimezone = newExamenblanc.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

    //     // Conversion de la date locale en objet Date
    //     const examDateLocal = new Date(newExamenblanc.date_examen);

    //     // Conversion de la date en UTC en fonction du fuseau horaire
    //     const examDateUTC = new Date(examDateLocal.getTime() - examDateLocal.getTimezoneOffset() * 60000);

    //     console.log(`Date sélectionnée (${selectedTimezone}) :`, examDateLocal);
    //     console.log(`Date convertie en UTC :`, examDateUTC);

    //     // Préparation des données à envoyer
    //     const examenData = {
    //         ...newExamenblanc,
    //         // date_examen: `${newExamenblanc.date_examen}T${newExamenblanc.heure_examen || '00:00'}`,
    //         // timezone: newExamenblanc.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
    //         date_examen: newExamenblanc.type_examen === 'Bootcamp'
    //             ? new Date().toISOString()
    //             : `${newExamenblanc.date_examen}T${newExamenblanc.heure_examen || '00:00'}`,
    //         timezone: newExamenblanc.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
    //     };

    //     // Si c'est un bootcamp, on force certaines valeurs
    //     if (newExamenblanc.type_examen === 'Bootcamp') {
    //         examenData.langue = 'Fr';
    //         examenData.nbre_heures = '1';
    //     }

    //     try {
    //         const response = await fetch(`${process.env.REACT_APP_HOTE}/enregistrer-examenblanc/${user_id}/`, {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //             body: JSON.stringify(examenData),
    //         });

    //         if (response.ok) {
    //             const data = await response.json();
    //             console.log('Examen enregistré avec succès');
    //             handleCloseModal();
    //             setIsButtonLoading(false);
    //             showAlert("Examen enregistré avec succès !");
    //             setNewExamenblanc({
    //                 date_examen: '',
    //                 type_examen: '',
    //                 langue: '',
    //                 nbre_heures: '',
    //                 non_traite: false,
    //                 tag: ''
    //             });
    //             await fetchExamen(user_id);
    //         } else {
    //             const errorData = await response.json();
    //             console.error('Erreur du serveur:', errorData);
    //             showAlertModal('Erreur lors de la réservation : ' + (errorData.error || 'Erreur inconnue.'), 'danger');
    //         }
    //     } catch (error) {
    //         console.error('Erreur réseau:', error);
    //         showAlert("Une erreur est survenue lors de l'enregistrement !");
    //     } finally {
    //         setIsButtonLoading(false);
    //     }
    // };

    const handleSubmitNewExamenblanc = async () => {
        // Vérification des champs obligatoires
        if (newExamenblanc.type_examen === 'Bootcamp' && !newExamenblanc.tag) {
            showAlertModal("Veuillez renseigner le tag du bootcamp !", 'danger');
            return;
        }
        if (newExamenblanc.type_examen !== 'Bootcamp') {
            if (!newExamenblanc.date_examen) {
                showAlertModal("Veuillez renseigner la date de l'examen !", 'danger');
                return;
            }
            if (!newExamenblanc.heure_examen) {
                showAlertModal("Veuillez renseigner l'heure de l'examen !", 'danger');
                return;
            }
            if (!newExamenblanc.type_examen) {
                showAlertModal("Veuillez renseigner le type d'examen !", 'danger');
                return;
            }
            if (!newExamenblanc.langue) {
                showAlertModal("Veuillez renseigner la langue de l'examen !", 'danger');
                return;
            }
            if (!newExamenblanc.nbre_heures) {
                showAlertModal("Veuillez indiquer le nombre d'heures !", 'danger');
                return;
            }
        }

        setIsButtonLoading(true);

        try {
            // Préparation des données à envoyer
            let dateTimeExamen;
            let timeExamen;

            if (newExamenblanc.type_examen === 'Bootcamp') {
                // Pour les bootcamps: format "YYYY-MM-DDTHH:mm:ss" avec l'heure actuelle
                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0');
                const day = String(now.getDate()).padStart(2, '0');
                const hours = String(now.getHours()).padStart(2, '0');
                const minutes = String(now.getMinutes()).padStart(2, '0');

                dateTimeExamen = `${year}-${month}-${day}T${hours}:${minutes}:00`;
                timeExamen = `${hours}:${minutes}:00`;
            } else {
                // Pour les autres examens: utiliser la date et heure du formulaire
                dateTimeExamen = `${newExamenblanc.date_examen}T${newExamenblanc.heure_examen}:00`;
            }

            const examenData = {
                ...newExamenblanc,
                date_examen: dateTimeExamen,
                timezone: newExamenblanc.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
                // Forcer les valeurs pour les bootcamps
                ...(newExamenblanc.type_examen === 'Bootcamp' && {
                    dateTime_examen: dateTimeExamen,
                    heure_examen: timeExamen,
                    langue: 'Fr',
                    nbre_heures: '1'
                })
            };

            const response = await fetch(`${process.env.REACT_APP_HOTE}/enregistrer-examenblanc/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(examenData),
            });

            if (response.ok) {
                const data = await response.json();
                console.log('Examen enregistré avec succès');
                handleCloseModal();
                showAlert("Examen enregistré avec succès !");
                setNewExamenblanc({
                    date_examen: '',
                    heure_examen: '',
                    type_examen: '',
                    langue: '',
                    nbre_heures: '',
                    non_traite: false,
                    tag: ''
                });
                await fetchExamen(user_id);
            } else {
                const errorData = await response.json();
                console.error('Erreur du serveur:', errorData);
                showAlertModal('Erreur lors de la réservation : ' + (errorData.error || 'Erreur inconnue.'), 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert("Une erreur est survenue lors de l'enregistrement !");
        } finally {
            setIsButtonLoading(false);
        }
    };

    // Filter examens by search term
    const filteredExamen = examen.filter(e =>
        (e.date_demande && e.date_demande.toString().includes(searchTerm.toLowerCase())) ||
        (e.date_examen && e.date_examen.toString().includes(searchTerm.toLowerCase())) ||
        (e.type_examen && e.type_examen?.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (e.tag && e.tag?.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (e.langue && e.langue?.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (e.nbre_heures && e.nbre_heures.toString().includes(searchTerm)) ||
        (e.non_traite !== undefined && e.non_traite.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
        (e.statut && e.statut?.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (e.motif && e.motif?.toLowerCase().includes(searchTerm.toLowerCase()))
    );


    // Sort examens
    const sortedExamen = [...filteredExamen].sort((a, b) => {
        const dateA = new Date(a[sortConfig.key].split('/').reverse().join('-')); // Convertir en format YYYY-MM-DD
        const dateB = new Date(b[sortConfig.key].split('/').reverse().join('-'));

        if (dateA < dateB) {
            return sortConfig.direction === 'descending' ? -1 : 1;
        }
        if (dateA > dateB) {
            return sortConfig.direction === 'descending' ? 1 : -1;
        }
        return 0;
    });


    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Pagination logic
    const indexOfLastExamen = currentPage * itemsPerPage;
    const indexOfFirstExamen = indexOfLastExamen - itemsPerPage;
    const currentExamen = sortedExamen.slice(indexOfFirstExamen, indexOfLastExamen);
    const totalPages = Math.ceil(sortedExamen.length / itemsPerPage);

    // Handle items per page change
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const checkExamenDescriptionOverflow = (examen) => {
        examen.forEach((e) => {
            const element = document.getElementById(`examen-description-${e.id}`);
            if (element) {
                setExamenDescriptionOverflows((prev) => ({
                    ...prev,
                    [e.id]: element.scrollHeight > element.clientHeight,
                }));
            }
        });
    };

    useEffect(() => {
        checkExamenDescriptionOverflow(examen);
    }, [examen]);





    // essai ................

    const [showModalEssai, setShowModalEssai] = useState(false);

    const handleCloseModalEssai = () => {
        setShowModalEssai(false);
        setAlertModal({ message: '', type: '' });
    }

    const handleShowModalEssai = () => setShowModalEssai(true);


    const handleSubmitEssai = async () => {
        // Validation des champs pour l'essai
        if (!newExamenblanc.code_essai) {
            showAlertModal("Veuillez renseigner le code de l'essai !", 'danger');
            return;
        }
        if (!newExamenblanc.langue) {
            showAlertModal("Veuillez renseigner la langue de l'essai !", 'danger');
            return;
        }
        // if (!newExamenblanc.plage_debut || !newExamenblanc.plage_fin) {
        //     showAlertModal("Veuillez renseigner la plage de questions !", 'danger');
        //     return;
        // }

        // // Validation de la plage
        // if (parseInt(newExamenblanc.plage_debut) >= parseInt(newExamenblanc.plage_fin)) {
        //     showAlertModal("La valeur 'Début' doit être inférieure à la valeur 'Fin' !", 'danger');
        //     return;
        // }

        setIsButtonLoading(true);

        try {
            // ✅ AJOUTER LE FUSEAU HORAIRE COMME POUR LES EXAMENS NORMALS
            const essaiData = {
                type_examen: 'Essai',
                code_essai: newExamenblanc.code_essai,
                langue: newExamenblanc.langue,
                plage_debut: newExamenblanc.plage_debut,
                plage_fin: newExamenblanc.plage_fin,
                timezone: newExamenblanc.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone, // ✅ Ajouter le fuseau horaire
            };

            const response = await fetch(`${process.env.REACT_APP_HOTE}/enregistrer-essai/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(essaiData),
            });

            if (response.ok) {
                const data = await response.json();
                console.log('Essai enregistré avec succès');
                handleCloseModalEssai();
                showAlert("Essai enregistré avec succès !");

                // Reset des champs
                setNewExamenblanc({
                    date_examen: '',
                    heure_examen: '',
                    type_examen: '',
                    langue: '',
                    nbre_heures: '',
                    non_traite: false,
                    code_essai: '',
                    plage_debut: '',
                    plage_fin: ''
                });

                await fetchExamen(user_id);
            } else {
                const errorData = await response.json();
                console.error('Erreur du serveur:', errorData);
                showAlertModal((errorData.error || 'Erreur inconnue.'), 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert("Une erreur est survenue lors de l'enregistrement !");
        } finally {
            setIsButtonLoading(false);
        }
    };


    // essai ................




    const [bootcampDetails, setBootcampDetails] = useState({
        date_examen: '',
        heure_examen: '',
        tag: '',
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    });

    // Fonction pour ouvrir le modal et récupérer les détails d'un examen blanc
    const handleShowModifierModal = async (examen) => {
        if (examen && user_id) {
            await fetchExamenblancDetails(examen.id, user_id);
        }
    };
    // const handleShowModifierBootcampModal = async (examen) => {
    //     if (examen && user_id) {
    //         await fetchExamenblancDetails(examen.id, user_id);
    //     }
    // };
    // Fonction pour ouvrir le modal et récupérer les détails d'un examen blanc
    const fetchExamenblancDetails = async (id, user_id) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-examenblanc/${id}/${user_id}/`);

            if (response.ok) {
                const data = await response.json();

                if (data.type_examen === 'Bootcamp') {
                    // Si c'est un bootcamp, utilisez setBootcampDetails
                    setBootcampDetails({
                        date_examen: data.date_examen.split('T')[0],
                        heure_examen: data.date_examen.split('T')[1]?.substring(0, 5) || '00:00',
                        tag: data.tag || '',
                        timezone: data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
                    });
                    setShowModifierBootcampModal(true)
                } else {
                    // Si c'est un examen normal, utilisez setExamenblancDetails
                    setExamenblancDetails({
                        date_examen: data.date_examen.split('T')[0],
                        heure_examen: data.date_examen.split('T')[1]?.substring(0, 5) || '00:00',
                        type_examen: data.type_examen,
                        langue: data.langue,
                        nbre_heures: data.nbre_heures,
                        non_traite: data.non_traite,
                        timezone: data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
                    });
                    setShowModifierModal(true);
                }



                setSelectedExamen(data);
            } else {
                console.error("Erreur lors de la récupération des données de l'examen blanc");
            }
        } catch (error) {
            console.error("Erreur lors de la requête :", error);
        }
    };




    const handleModifierBootcamp = async () => {
        // Validation des champs
        if (!bootcampDetails.date_examen) {
            showAlertModal("Veuillez sélectionner une date pour le bootcamp", 'danger');
            return;
        }
        if (!bootcampDetails.heure_examen) {
            showAlertModal("Veuillez sélectionner une heure pour le bootcamp", 'danger');
            return;
        }
        if (!bootcampDetails.tag) {
            showAlertModal("Veuillez renseigner un tag pour le bootcamp", 'danger');
            return;
        }

        try {
            const bootcampData = {
                date_examen: `${bootcampDetails.date_examen}T${bootcampDetails.heure_examen}:00`,
                tag: bootcampDetails.tag,
                timezone: bootcampDetails.timezone,
                type_examen: 'Bootcamp',
                langue: 'Fr',
                nbre_heures: '1'
            };

            const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-examenblanc/${selectedExamen?.id}/${user_id}/`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(bootcampData)
            });

            if (response.ok) {
                showAlert("Bootcamp modifié avec succès !");
                setShowModifierBootcampModal(false);
                fetchExamen(user_id);
            } else {
                const errorData = await response.json();
                showAlertModal('Erreur lors de la modification : ' + (errorData.error || 'Erreur inconnue.'), 'danger');
            }
        } catch (error) {
            console.error("Erreur lors de la requête :", error);
            showAlertModal("Erreur réseau lors de la modification", 'danger');
        }
    };

    // Handle modifier un examen blanc
    const handleModifierExamen = async () => {
        setIsButtonLoading(true)
        if (selectedExamen && user_id) { // Assurez-vous que selectedExamen et user_id sont disponibles
            // Vérification des champs obligatoires avec des messages spécifiques
            if (!examenblancDetails.date_examen) {
                showAlertModal("Veuillez renseigner la date et l'heure de l'examen !", 'danger');
                return;
            }
            if (!examenblancDetails.type_examen) {
                showAlertModal("Veuillez renseigner le type d'examen !", 'danger');
                return;
            }
            if (!examenblancDetails.langue) {
                showAlertModal("Veuillez renseigner la langue de l'examen !", 'danger');
                return;
            }
            if (!examenblancDetails.nbre_heures) {
                showAlertModal("Veuillez indiquer le nombre d'heures !", 'danger');
                return;
            }

            // Récupération du fuseau horaire sélectionné ou du fuseau par défaut de l'utilisateur
            const selectedTimezone = examenblancDetails.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

            // Conversion de la date locale en objet Date
            const examDateLocal = new Date(examenblancDetails.date_examen);

            // Conversion de la date en UTC en fonction du fuseau horaire
            const examDateUTC = new Date(examDateLocal.getTime() - examDateLocal.getTimezoneOffset() * 60000);

            console.log(`Date sélectionnée (${selectedTimezone}) :`, examDateLocal);
            console.log(`Date convertie en UTC :`, examDateUTC);

            // Création de l'objet à envoyer au backend
            const examenData = {
                ...examenblancDetails,
                date_examen: examDateUTC.toISOString(), // Envoi de la date en UTC au format ISO
                timezone: selectedTimezone // Ajout du fuseau horaire pour info
            };

            try {
                const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-examenblanc/${selectedExamen?.id}/${user_id}/`, {
                    method: "PUT", // Ou utilisez "PATCH" si c'est une mise à jour partielle
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(examenData) // Assurez-vous que examenblancDetails contient les bonnes données
                });

                if (response.ok) {
                    console.log("Examen blanc mis à jour avec succès");
                    setShowModifierModal(false); // Ferme le modal après la mise à jour
                    showAlert("Examen blanc modifié avec succès !");
                    setSelectedExamen(null)
                    await fetchExamen(user_id); // Rafraîchir les données après la mise à jour// Rafraîchir les données si nécessaire

                    // window.location.reload()
                } else {
                    const errorData = await response.json();
                    console.error('Erreur du serveur:', errorData);
                    //showAlertModal("Erreur lors de la modification de l'examen blanc !");
                    showAlertModal('Erreur lors de la modification de l\'examen blanc : ' + (errorData.error || 'Erreur inconnue.'), 'danger');
                }
            } catch (error) {
                console.error("Erreur lors de la requête :", error);
            } finally {

                setIsButtonLoading(false)
            }
        } else {
            console.error("Identifiant d'examen ou identifiant d'utilisateur manquant");
            showAlert("Identifiant d'examen ou identifiant d'utilisateur manquant");
        }

        // console.log(examenblancDetails);
    };


    const handleDemarrerExamen = (examen_id) => {
        if (examen_id) {
            navigate(`/demarrer-examen`, {
                state: { examen_id: examen_id, nbre_heures: selectedExamen?.nbre_heures, statut: selectedExamen?.statut, pauseChoice: pauseChoice, type_examen: selectedExamen?.type_examen },
            });
        }
    };

    const handleResultatExamen = (examen_id) => {
        if (examen_id) {
            navigate(`/Resultat-examen`, {
                state: { examen_id: examen_id, user_id: user_id },
            });
        }
    };


    const isDatePassedOrEqualNow = (dateString) => {
        try {
            console.log('dateString :', dateString);

            // Diviser la date et l'heure
            const [datePart, timePart] = dateString.trim().split(' '); // Séparation entre la date et l'heure

            // Séparer le jour, mois, année
            const [day, month, year] = datePart.split('/').map(Number);

            // Séparer les heures et les minutes
            const [hours, minutes] = timePart.split(':').map(Number);

            // Créer l'objet Date pour l'examen en heure locale
            const examDate = new Date(year, month - 1, day, hours, minutes);
            console.log('examDate (local) :', examDate);

            // Obtenir la date actuelle en heure locale
            const now = new Date();
            console.log('now (local) :', now);

            // Comparaison des dates en heure locale
            if (now >= examDate) {
                console.log('actif');
            } else {
                console.log('Pas actif');
            }

            // Retourner vrai si la date actuelle est supérieure ou égale à la date de l'examen
            return now >= examDate;
        } catch (error) {
            console.error("Erreur dans la comparaison :", error);
            return false;
        }
    };


    // const isDatePassedOrEqualNow = (dateString) => {
    //     try {
    //         // Diviser la date et l'heure
    //         const [datePart, timePart] = dateString.trim().split(' ');

    //         // Séparer le jour, mois, année
    //         const [day, month, year] = datePart.split('/').map(Number);

    //         // Séparer les heures et les minutes
    //         const [hours, minutes] = timePart.split(':').map(Number);

    //         // Créer l'objet Date en UTC
    //         const examDate = new Date(Date.UTC(year, month - 1, day, hours, minutes));

    //         // Obtenir l'heure actuelle en UTC
    //         const now = new Date();
    //         const nowUTC = new Date(Date.UTC(
    //             now.getUTCFullYear(),
    //             now.getUTCMonth(),
    //             now.getUTCDate(),
    //             now.getUTCHours(),
    //             now.getUTCMinutes()
    //         ));

    //         console.log("Exam Date (UTC) :", examDate);
    //         console.log("Now (UTC) :", nowUTC);

    //         if (nowUTC >= examDate) {
    //             console.log("c'est bon");
    //         } else {
    //             console.log("c'est pas bon");
    //         }

    //         // Comparaison
    //         return nowUTC >= examDate;
    //     } catch (error) {
    //         console.error("Erreur dans isDatePassedOrEqualNow :", error);
    //         return false;
    //     }
    // };



    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("ExamenBlanc")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaNewspaper size={25} className='mr-2' />Gestion des examens</h2>
                            <small>Pour commencer votre examen, sélectionnez-le dans la liste puis cliquez sur le bouton 'Démarrer' - vous aurez le choix entre un mode avec pauses recommandé ou un mode continu.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Historique-examen`}> Examens</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Historique de mes examens</h5>
                                <div className="d-flex">
                                    {/* <Link to={`/Examen-favoris`} className="btn btn-success mr-2 ms-2 mt-1">
                                        <FaHeart /> Favoris
                                    </Link> */}

                                    <button
                                        className="btn btn-success d-flex align-items-center justify-content-center ms-2 mr-2 mt-1"
                                        onClick={() => {
                                            setNewExamenblanc({
                                                date_examen: '',
                                                heure_examen: '',
                                                type_examen: '',
                                                langue: '',
                                                nbre_heures: '',
                                                non_traite: false,
                                                tag: ''
                                            });
                                            handleShowModal();
                                        }}
                                    >
                                        <FaPlus />
                                        <span className="d-none d-sm-inline ml-2">
                                            Réserver Examen
                                        </span>
                                    </button>


                                    {/* <button className="btn btn-success d-flex align-items-center justify-content-center ms-2 mr-2 mt-1" onClick={() => {
                                        setNewExamenblanc({
                                            date_examen: '',
                                            type_examen: 'Bootcamp',
                                            langue: 'Fr',
                                            nbre_heures: '1',
                                            non_traite: false,
                                            tag: ''
                                        });
                                        handleShowModal();
                                    }}>
                                        <FaPlus />
                                        <span className="d-none d-sm-inline ml-2">
                                            Réserver Bootcamp
                                        </span>
                                    </button> */}


                                    <button
                                        className="btn btn-success d-flex align-items-center justify-content-center ms-2 mr-2 mt-1"
                                        onClick={() => {
                                            setNewExamenblanc({
                                                type_examen: 'Essai',
                                                langue: 'Fr',
                                                non_traite: false,
                                                code_essai: '',
                                                plage_debut: '',
                                                plage_fin: ''
                                            });
                                            handleShowModalEssai();
                                        }}
                                    >
                                        <FaPlus />
                                        <span className="d-none d-sm-inline ml-2">
                                            Réserver un essai
                                        </span>
                                    </button>


                                    <button
                                        onClick={() => handleShowModifierModal(selectedExamen)}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedExamen &&
                                            (selectedExamen?.statut === "En cours de validation" && selectedExamen?.type_examen !== "Essai")
                                            ? 'btn-success'
                                            : 'btn-default text-dark'
                                            }`}
                                        disabled={
                                            !selectedExamen ||
                                            (selectedExamen?.statut !== "En cours de validation") ||
                                            (selectedExamen?.type_examen === "Essai") // ✅ Désactiver pour les essais
                                        }
                                    >
                                        <FaEdit />
                                        <span className="d-none d-sm-inline ml-2">
                                            Modifier examen
                                        </span>
                                    </button>

                                    {/* <button
                                        onClick={() => handleShowModifierBootcampModal(selectedExamen)}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedExamen &&
                                                (selectedExamen?.statut === "En cours de validation" ||
                                                    (selectedExamen?.type_examen === "Bootcamp" && selectedExamen?.statut === "Termine"))
                                                ? 'btn-success'
                                                : 'btn-default text-dark'
                                            }`}
                                        disabled={
                                            !selectedExamen ||
                                            (
                                                selectedExamen?.statut !== "En cours de validation" &&
                                                !(selectedExamen?.type_examen === "Bootcamp" && selectedExamen?.statut === "Termine")
                                            )
                                        }
                                    >
                                        <FaEdit />
                                        <span className="d-none d-sm-inline ml-2">
                                            Modifier bootcamp
                                        </span>
                                    </button> */}

                                    <button
                                        onClick={() => {
                                            if (examen_id_strored && selectedExamen?.id === examen_id_strored) {
                                                // Mode "Continuer" : Lancer directement l'examen
                                                handleDemarrerExamen(selectedExamen?.id);
                                            } else {
                                                // Mode "Démarrer" : Afficher le modal
                                                setShowDemarageModal(true);
                                            }
                                        }}
                                        // onClick={() => handleDemarrerExamen(selectedExamen?.id)}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedExamen &&
                                            selectedExamen?.statut === "Approuve" &&
                                            isDatePassedOrEqualNow(selectedExamen?.date_examen) &&
                                            (!examen_id_strored || selectedExamen?.id === examen_id_strored)
                                            ? 'btn-success'
                                            : 'btn-default'
                                            }`}
                                        disabled={Boolean(
                                            !selectedExamen ||
                                            !isDatePassedOrEqualNow(selectedExamen?.date_examen) ||
                                            selectedExamen?.statut !== "Approuve" ||
                                            (examen_id_strored && selectedExamen?.id !== examen_id_strored)
                                        )}
                                    >
                                        <FaPlay />
                                        <span className="d-none d-sm-inline ml-2">
                                            {examen_id_strored && selectedExamen?.id === examen_id_strored && stored ? 'Continuer' : 'Démarrer'}
                                        </span>
                                    </button>

                                    {/* Bouton Recommencer - Toujours visible mais conditionnellement actif */}
                                    <button
                                        onClick={() => {
                                            if (selectedExamen?.type_examen === "Essai" && selectedExamen?.statut === "Termine") {
                                                setShowDemarageModal(true);
                                            }
                                        }}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedExamen?.type_examen === "Essai" && selectedExamen?.statut === "Termine"
                                            ? 'btn-warning'
                                            : 'btn-default text-muted'
                                            }`}
                                        disabled={!selectedExamen || selectedExamen?.type_examen !== "Essai" || selectedExamen?.statut !== "Termine"}
                                    >
                                        <FaPlay />
                                        <span className="d-none d-sm-inline ml-2">
                                            Recommencer essai
                                        </span>
                                    </button>

                                    <button
                                        onClick={() => handleResultatExamen(selectedExamen?.id)}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mt-1 ${selectedExamen && selectedExamen?.statut === "Termine" && isDatePassedOrEqualNow(selectedExamen?.date_examen)
                                            ? 'btn-success'
                                            : 'btn-default text-dark'
                                            }`}
                                        disabled={!selectedExamen || !isDatePassedOrEqualNow(selectedExamen?.date_examen) || selectedExamen?.statut !== "Termine"}
                                    >
                                        <FaNewspaper />
                                        <span className="d-none d-sm-inline ml-2">
                                            Résultats
                                        </span>
                                    </button>
                                </div>

                                {/* Modal pour Réserver un examen */}
                                <Modal show={showModal} onHide={handleCloseModal}>
                                    <Modal.Header>
                                        <Modal.Title>
                                            {newExamenblanc.type_examen === 'Bootcamp' ?
                                                'Réserver un Bootcamp' :
                                                'Réserver un Examen blanc'}
                                        </Modal.Title>
                                    </Modal.Header>
                                    {alertModal.message && (
                                        <div className={`m-3 alert alert-${alertModal.type}`}>
                                            {alertModal.message}
                                        </div>
                                    )}
                                    <Modal.Body>
                                        <Form>
                                            {newExamenblanc.type_examen !== 'Bootcamp' && (
                                                <Form.Group controlId="formTimezone" className="">
                                                    <Form.Label>Fuseau horaire</Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        name="timezone"
                                                        value={newExamenblanc.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone}
                                                        onChange={handleNewExamenblancChange}
                                                        required
                                                    >
                                                        {timezones.map((tz) => (
                                                            <option key={tz.tzCode} value={tz.tzCode}>
                                                                {tz.label} ({tz.tzCode})
                                                            </option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                            )}
                                            {newExamenblanc.type_examen !== 'Bootcamp' && (
                                                <Form.Group controlId="formDateExamenblanc" className="mt-3">
                                                    <Form.Label>Date de l'examen</Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        name="date_examen"
                                                        value={newExamenblanc.date_examen}
                                                        onChange={handleNewExamenblancChange}
                                                        min={new Date().toISOString().split("T")[0]}
                                                        required
                                                    />
                                                </Form.Group>
                                            )}
                                            {newExamenblanc.type_examen !== 'Bootcamp' && (
                                                <Form.Group controlId="formHeureExamenblanc" className="mt-3">
                                                    <Form.Label>Heure de l'examen</Form.Label>
                                                    <Form.Control
                                                        type="time"
                                                        name="heure_examen"
                                                        value={newExamenblanc.heure_examen}
                                                        onChange={handleNewExamenblancChange}
                                                        required
                                                    />
                                                </Form.Group>
                                            )}


                                            {/* Type d'examen */}
                                            <Form.Group controlId="typeExamenblanc" className="mt-3">
                                                <Form.Label>Type d'examen</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name="type_examen"
                                                    value={newExamenblanc.type_examen}
                                                    onChange={handleNewExamenblancChange}
                                                    disabled={newExamenblanc.type_examen === 'Bootcamp'}
                                                    required
                                                >
                                                    <option value="">Sélectionnez le type</option>
                                                    <option value="PMP">PMP</option>
                                                    <option value="CAPM">CAPM</option>
                                                    <option value="Bootcamp">Bootcamp</option>
                                                </Form.Control>
                                            </Form.Group>

                                            {/* Champ Tag (visible seulement pour Bootcamp) */}
                                            {newExamenblanc.type_examen === 'Bootcamp' && (
                                                <Form.Group controlId="formTag" className="mt-3">
                                                    <Form.Label>Tag</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="tag"
                                                        placeholder="Entrez le tag du bootcamp"
                                                        value={newExamenblanc.tag || ''}
                                                        onChange={handleNewExamenblancChange}
                                                        required
                                                    />
                                                </Form.Group>
                                            )}

                                            {/* Langue */}
                                            <Form.Group controlId="langueExamenblanc" className="mt-3">
                                                <Form.Label>Langue</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name="langue"
                                                    value={newExamenblanc.langue}
                                                    onChange={handleNewExamenblancChange}
                                                    required
                                                    disabled={newExamenblanc.type_examen === 'Bootcamp'}
                                                >
                                                    <option value="">Sélectionnez la langue</option>
                                                    <option value="Fr">Français</option>
                                                    <option value="Ang">Anglais</option>
                                                </Form.Control>
                                            </Form.Group>

                                            {/* Nombres d'heures */}
                                            <Form.Group controlId="formNbreHeures" className="mt-3">
                                                <Form.Label>Nombres d'heures</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name="nbre_heures"
                                                    value={newExamenblanc.nbre_heures}
                                                    onChange={handleNewExamenblancChange}
                                                    required
                                                    disabled={newExamenblanc.type_examen === 'Bootcamp'}
                                                >
                                                    <option value="">Sélectionnez le nombre d'heures</option>
                                                    <option value="1">1 Heure (50 QCMs)</option>
                                                    {newExamenblanc.type_examen !== 'Bootcamp' && (
                                                        <>
                                                            <option value="3">3 Heures (150 QCMs)</option>
                                                            <option value="4">4 Heures (200 QCMs)</option>
                                                        </>
                                                    )}
                                                </Form.Control>
                                            </Form.Group>
                                        </Form>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="default" onClick={handleCloseModal}>
                                            Fermer
                                        </Button>
                                        {isButtonLoading ? (
                                            <button className="btn btn-success mr-2" disabled>
                                                <i className="fa fa-spinner fa-spin mr-1"></i>
                                                <span className="d-none d-sm-inline ml-2">
                                                    Chargement...
                                                </span>
                                            </button>
                                        ) : (
                                            <Button variant="success" onClick={handleSubmitNewExamenblanc}>
                                                Enregistrer
                                            </Button>
                                        )}
                                    </Modal.Footer>
                                </Modal>

                                {/* Modal pour modifier examen */}
                                <Modal show={showModifierModal} onHide={handleCloseModifierModal}>
                                    <Modal.Header>
                                        <Modal.Title>Modifier Examen blanc</Modal.Title>
                                    </Modal.Header>
                                    {alertModal.message && (
                                        <div className={`m-3 alert alert-${alertModal.type}`}>
                                            {alertModal.message}
                                        </div>
                                    )}
                                    <Modal.Body>
                                        <Form>
                                            <Form.Group controlId="formTimezone" className="">
                                                <Form.Label>Fuseau horaire</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name="timezone"
                                                    value={examenblancDetails.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone} // Défaut : timezone utilisateur
                                                    onChange={handleExamenblancDetailsChange}
                                                    required
                                                >
                                                    {timezones.map((tz) => (
                                                        <option key={tz.tzCode} value={tz.tzCode}>
                                                            {tz.label} ({tz.tzCode})
                                                        </option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>
                                            {/* Date d'Examen */}
                                            {/* <Form.Group controlId="formDateExamenblanc">
                                                <Form.Label>Date et heure d'examen</Form.Label>
                                                <Form.Control
                                                    type="datetime-local"
                                                    name="date_examen"
                                                    value={examenblancDetails.date_examen}
                                                    onChange={handleExamenblancDetailsChange}
                                                    min={new Date().toISOString().slice(0, 16)} // Définit la date et l'heure minimale à maintenant
                                                    required
                                                />
                                            </Form.Group> */}

                                            {/* Date d'Examen */}
                                            <Form.Group controlId="formDateExamenblanc" className="mt-3">
                                                <Form.Label>Date de l'examen</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    name="date_examen"
                                                    value={examenblancDetails.date_examen}
                                                    onChange={handleExamenblancDetailsChange}
                                                    min={new Date().toISOString().split("T")[0]} // Empêche de choisir une date passée
                                                    required
                                                />
                                            </Form.Group>

                                            {/* Heure d'Examen */}
                                            <Form.Group controlId="formHeureExamenblanc" className="mt-3">
                                                <Form.Label>Heure de l'examen</Form.Label>
                                                <Form.Control
                                                    type="time"
                                                    name="heure_examen"
                                                    value={examenblancDetails.heure_examen}
                                                    onChange={handleExamenblancDetailsChange}
                                                    required
                                                />
                                            </Form.Group>

                                            {/* Type d'examen */}
                                            <Form.Group controlId="typeExamenblanc" className="mt-3">
                                                <Form.Label>Type d'examen</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name="type_examen"
                                                    value={examenblancDetails.type_examen}
                                                    onChange={handleExamenblancDetailsChange}
                                                    required
                                                >
                                                    <option value="">Sélectionnez le type</option>
                                                    <option value="PMP">PMP</option>
                                                    <option value="CAPM">CAPM</option>
                                                    {/* Ajouter d'autres types d'examens si nécessaire */}
                                                </Form.Control>
                                            </Form.Group>

                                            <Form.Group controlId="langueExamenblanc" className="mt-3">
                                                <Form.Label>Langue</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name="langue"
                                                    value={examenblancDetails.langue || ''}
                                                    required
                                                    onChange={handleExamenblancDetailsChange}
                                                >
                                                    <option value="">Sélectionnez la langue</option>
                                                    <option value="Fr">Francais</option>
                                                    <option value="Ang">Anglais</option>
                                                </Form.Control>
                                            </Form.Group>

                                            {/* Nombres d'heures */}
                                            <Form.Group controlId="formNbreHeures" className="mt-3">
                                                <Form.Label>Nombres d'heures</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name="nbre_heures"
                                                    value={examenblancDetails.nbre_heures || ''}
                                                    required
                                                    onChange={handleExamenblancDetailsChange}
                                                >
                                                    <option value="">Sélectionnez le nombre d'heures</option>
                                                    <option value="1">1 Heure (50 QCMs)</option>
                                                    <option value="3">3 Heures (150 QCMs)</option>
                                                    <option value="4">4 Heures (200 QCMs)</option>
                                                </Form.Control>
                                            </Form.Group>

                                            {/* Case à cocher : QCM non traités */}
                                            {/* <Form.Group controlId="formNonTraite" className="mt-3">
                                                <Form.Check
                                                    type="checkbox"
                                                    label="Afficher seulement les QCM non traités"
                                                    name="non_traite"
                                                    checked={examenblancDetails.non_traite}
                                                    onChange={(e) => {
                                                        handleExamenblancDetailsChange(e); // Gérer le changement
                                                    }}
                                                />
                                            </Form.Group> */}
                                        </Form>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="default" onClick={handleCloseModifierModal}>
                                            Fermer
                                        </Button>
                                        {isButtonLoading ? (
                                            <button className="btn btn-success mr-2" disabled>
                                                <i className="fa fa-spinner fa-spin mr-1"></i>
                                                <span className="d-none d-sm-inline ml-2">
                                                    Chargement...
                                                </span>
                                            </button>
                                        ) : (
                                            <Button variant="success" onClick={handleModifierExamen}>
                                                Modifier
                                            </Button>
                                        )}
                                    </Modal.Footer>
                                </Modal>



                                {/* Modal pour modifier bootcamp */}
                                <Modal show={showModifierBootcampModal && selectedExamen?.type_examen === 'Bootcamp'} onHide={handleCloseModifierBootcampModal}>
                                    <Modal.Header>
                                        <Modal.Title>Modifier Bootcamp</Modal.Title>
                                    </Modal.Header>
                                    {alertModal.message && (
                                        <div className={`m-3 alert alert-${alertModal.type}`}>
                                            {alertModal.message}
                                        </div>
                                    )}
                                    <Modal.Body>
                                        <Form>
                                            <Form.Group controlId="formTimezone" className="mb-3">
                                                <Form.Label>Fuseau horaire</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name="timezone"
                                                    value={bootcampDetails.timezone}
                                                    onChange={(e) => setBootcampDetails({ ...bootcampDetails, timezone: e.target.value })}
                                                    required
                                                >
                                                    {timezones.map((tz) => (
                                                        <option key={tz.tzCode} value={tz.tzCode}>
                                                            {tz.label} ({tz.tzCode})
                                                        </option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>

                                            <Form.Group controlId="formDateExamen" className="mb-3">
                                                <Form.Label>Date du bootcamp</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    name="date_examen"
                                                    value={bootcampDetails.date_examen}
                                                    onChange={(e) => setBootcampDetails({ ...bootcampDetails, date_examen: e.target.value })}
                                                    min={new Date().toISOString().split("T")[0]}
                                                    required
                                                />
                                            </Form.Group>

                                            <Form.Group controlId="formHeureExamen" className="mb-3">
                                                <Form.Label>Heure du bootcamp</Form.Label>
                                                <Form.Control
                                                    type="time"
                                                    name="heure_examen"
                                                    value={bootcampDetails.heure_examen}
                                                    onChange={(e) => setBootcampDetails({ ...bootcampDetails, heure_examen: e.target.value })}
                                                    required
                                                />
                                            </Form.Group>

                                            <Form.Group controlId="formTag" className="mb-3">
                                                <Form.Label>Tag</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="tag"
                                                    placeholder="Entrez le tag identifiant le bootcamp"
                                                    value={bootcampDetails.tag}
                                                    onChange={(e) => setBootcampDetails({ ...bootcampDetails, tag: e.target.value })}
                                                    required
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleCloseModifierBootcampModal}>
                                            Annuler
                                        </Button>
                                        <Button variant="success" onClick={handleModifierBootcamp}>
                                            Enregistrer
                                        </Button>
                                    </Modal.Footer>
                                </Modal>


                                {/* Modal pour Réserver un essai - NOUVEAU MODAL SEPARÉ */}
                                <Modal show={showModalEssai} onHide={handleCloseModalEssai}>
                                    <Modal.Header>
                                        <Modal.Title>Réserver un essai</Modal.Title>
                                    </Modal.Header>
                                    {alertModal.message && (
                                        <div className={`m-3 alert alert-${alertModal.type}`}>
                                            {alertModal.message}
                                        </div>
                                    )}
                                    <Modal.Body>
                                        <Form>
                                            {/* SUPPRIMER le fuseau horaire puisque comme bootcamp */}

                                            <Form.Group controlId="formCodeEssai" className="mt-1">
                                                <Form.Label>Code de l'essai</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="code_essai"
                                                    placeholder=""
                                                    value={newExamenblanc.code_essai || ''}
                                                    onChange={handleNewExamenblancChange}
                                                    required
                                                />
                                                {/* <Form.Text className="text-muted">
                                                    Format: NOM_DU_TAG:DEBUT-FIN (ex: PROCESSUS:10-25)
                                                </Form.Text> */}
                                            </Form.Group>

                                            <Form.Group controlId="langueEssai" className="mt-3">
                                                <Form.Label>Langue</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name="langue"
                                                    value={newExamenblanc.langue}
                                                    onChange={handleNewExamenblancChange}
                                                    required
                                                >
                                                    <option value="">Sélectionnez la langue</option>
                                                    <option value="Fr">Français</option>
                                                    <option value="Ang">Anglais</option>
                                                </Form.Control>
                                            </Form.Group>

                                            {/* Plage de nombres - sur la même ligne */}
                                            {/* <Form.Group className="mt-3">
                                                <Form.Label>Plage de questions</Form.Label>
                                                <div className="row">
                                                    <div className="col">
                                                        <Form.Control
                                                            type="number"
                                                            name="plage_debut"
                                                            placeholder="Début"
                                                            value={newExamenblanc.plage_debut || ''}
                                                            onChange={handleNewExamenblancChange}
                                                            required
                                                            min="1"
                                                        />
                                                    </div>
                                                    <div className="col">
                                                        <Form.Control
                                                            type="number"
                                                            name="plage_fin"
                                                            placeholder="Fin"
                                                            value={newExamenblanc.plage_fin || ''}
                                                            onChange={handleNewExamenblancChange}
                                                            required
                                                            min="1"
                                                        />
                                                    </div>
                                                </div>
                                                <Form.Text className="text-muted">
                                                    Définir la plage de questions pour cet essai
                                                </Form.Text>
                                            </Form.Group> */}
                                        </Form>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="default" onClick={handleCloseModalEssai}>
                                            Fermer
                                        </Button>
                                        {isButtonLoading ? (
                                            <button className="btn btn-success mr-2" disabled>
                                                <i className="fa fa-spinner fa-spin mr-1"></i>
                                                <span className="d-none d-sm-inline ml-2">
                                                    Chargement...
                                                </span>
                                            </button>
                                        ) : (
                                            <Button variant="success" onClick={handleSubmitEssai}>
                                                Enregistrer
                                            </Button>
                                        )}
                                    </Modal.Footer>
                                </Modal>


                                <Modal show={showDemarageModal} onHide={() => setShowDemarageModal(false)}>
                                    <Modal.Header>
                                        <Modal.Title>Informations Importantes</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {selectedExamen?.type_examen === 'Essai' ? (
                                            // Message court pour les essais
                                            <div>
                                                <p><strong>Essai en mode démonstration</strong></p>
                                                <p>Cet essai vous permet de vous familiariser avec l'interface d'examen sans contrainte de temps.</p>
                                                <ul>
                                                    <li>Navigation libre entre les questions</li>
                                                    <li>Aucune limite de temps</li>
                                                    <li>Résultats disponibles immédiatement</li>
                                                </ul>
                                            </div>
                                        ) : (
                                            // Message original pour les examens normaux
                                            <div>
                                                <p>Cher apprenant, avant de commencer votre examen, voici quelques informations essentielles à retenir :</p>
                                                <ul>
                                                    <li><strong>Connexion Internet :</strong> Assurez-vous d'avoir une connexion internet stable et de bonne qualité pour éviter toute interruption.</li>
                                                    <li><strong>Durée de l'examen :</strong> Votre examen durera <strong>{selectedExamen?.nbre_heures} heure(s)</strong>. Toutes les <strong>{(selectedExamen?.nbre_heures * 60) / 3} minutes</strong>, vous aurez la possibilité de prendre une pause de <strong>10 minutes</strong>.</li>
                                                    <li><strong>Pendant la pause :</strong> Vous ne pourrez pas naviguer entre les questions, mais vous aurez accès au récapitulatif de vos réponses.</li>
                                                </ul>
                                                <p><strong>Option de pause :</strong> Souhaitez-vous passer votre examen avec ou sans pause ? La pause n'est pas obligatoire.</p>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="pauseOption"
                                                        id="avecPause"
                                                        value="avecPause"
                                                        checked={pauseChoice === "avecPause"}
                                                        onChange={() => setPauseChoice("avecPause")}
                                                    />
                                                    <label className="form-check-label" htmlFor="avecPause">
                                                        Avec pause (recommandé)
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="pauseOption"
                                                        id="sansPause"
                                                        value="sansPause"
                                                        checked={pauseChoice === "sansPause"}
                                                        onChange={() => setPauseChoice("sansPause")}
                                                    />
                                                    <label className="form-check-label" htmlFor="sansPause">
                                                        Sans pause
                                                    </label>
                                                </div>
                                                <p className="mt-3"><strong>Note :</strong> Les temps de pause seront déduits de votre temps réglementaire (<strong>{selectedExamen?.nbre_heures} heure(s)</strong>).</p>
                                            </div>
                                        )}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <button className="btn btn-secondary" onClick={() => setShowDemarageModal(false)}>
                                            Annuler
                                        </button>
                                        <button className="btn btn-success" onClick={() => handleDemarrerExamen(selectedExamen?.id)}>
                                            {selectedExamen?.type_examen === 'Essai' ? 'Commencer l\'essai' : 'Commencer l\'examen'}
                                        </button>
                                    </Modal.Footer>
                                </Modal>



                            </div>

                            {alert.message && (
                                <div className={`alert alert-${alert.type}`}>
                                    {alert.message}
                                </div>
                            )}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control col-md-3"
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>

                                            <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                    <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                        <thead>
                                                            <tr>
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('date_demande')}>
                                                                    Date de demande {sortConfig.key === 'date_demande'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('date_examen')}>
                                                                    Date d'examen {sortConfig.key === 'date_examen'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                                <th className='text-secondary text-center' onClick={() => handleSort('id')}>
                                                                    Ref {sortConfig.key === 'id'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('type')}>
                                                                    Type d'examen {sortConfig.key === 'type_examen'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('langue')}>
                                                                    Langue {sortConfig.key === 'langue'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('heures')}>
                                                                    Nombres d'heures {sortConfig.key === 'nbre_heures'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                                {/* NOUVELLE COLONNE PLAGE */}
                                                                {/* <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('plage_debut')}>
                                                                    Plage {sortConfig.key === 'plage_debut'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('tag')}>
                                                                    Code {sortConfig.key === 'tag'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th> */}
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('statut')}>
                                                                    Statut {sortConfig.key === 'statut'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('motif')}>
                                                                    Motif {sortConfig.key === 'motif'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('score')}>
                                                                    Score {sortConfig.key === 'score'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {!isLoading ? (
                                                                currentExamen.map((examen) => {
                                                                    return (
                                                                        <tr
                                                                            key={examen.id}
                                                                            onClick={() => handleRowClick(examen)}
                                                                            className={`bg-white ${selectedExamen && selectedExamen?.id === examen.id ? 'bg-success text-white' : ''}`}
                                                                        >
                                                                            <td>
                                                                                {examen.date_demande}
                                                                                <div className='lesInfos'>
                                                                                    <small>Date de demande : {examen.date_demande}</small><br />
                                                                                    <small>Date d'examen : {examen.date_examen}</small><br />
                                                                                    <small>Type d'examen : {examen.type_examen}</small><br />
                                                                                    <small>Nombres d'heure : {examen.nbre_heures}</small><br />
                                                                                    {/* AFFICHER LA PLAGE DANS LES INFOS */}
                                                                                    {/* {examen.plage_debut && examen.plage_fin && (
                                        <small>Plage : {examen.plage_debut} - {examen.plage_fin}</small><br />
                                    )} */}
                                                                                    {/* <small>Code : {examen.tag}</small><br /> */}
                                                                                    <small>Statut : {examen.statut}</small><br />
                                                                                    <small>Motif : {examen.motif}</small><br />
                                                                                    <small style={{ color: examen.pourcent ? (Number(examen.pourcent) < 80 ? 'red' : 'green') : 'inherit' }}>Score :
                                                                                        {examen.total_questions && examen.nombre_correct && examen.pourcent ?
                                                                                            `${examen.nombre_correct}/${examen.total_questions} (${examen.pourcent ? examen.pourcent + '%' : ''})`
                                                                                            : ' '
                                                                                        }
                                                                                    </small>
                                                                                </div>
                                                                            </td>

                                                                            <td className="d-none d-md-table-cell">{examen.date_examen}</td>
                                                                            <td className="d-none d-md-table-cell text-center">{examen.id}</td>
                                                                            <td className="d-none d-md-table-cell text-center">{examen.type_examen}</td>
                                                                            <td className="d-none d-md-table-cell text-center">{examen.langue}</td>
                                                                            <td className="d-none d-md-table-cell text-center">{examen.nbre_heures}</td>
                                                                            {/* NOUVELLE CELLULE POUR LA PLAGE */}
                                                                            {/* <td className="d-none d-md-table-cell text-center">
                                                                                {examen.plage_debut && examen.plage_fin ?
                                                                                    `${examen.plage_debut} - ${examen.plage_fin}` :
                                                                                    '-'
                                                                                }
                                                                            </td> */}
                                                                            {/* <td className="d-none d-md-table-cell text-center">{examen.tag}</td> */}
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {examen.statut === "Approuve" && "Approuvé"}
                                                                                {examen.statut === "Rejete" && "Rejeté"}
                                                                                {examen.statut === "Termine" && "Terminé"}
                                                                                {examen.statut === "En cours de validation" && "En cours de validation"}
                                                                            </td>
                                                                            <td className="d-none d-md-table-cell text-center">{examen.motif}</td>
                                                                            <td
                                                                                className="d-none d-md-table-cell text-center"
                                                                                style={{ color: examen.pourcent ? (Number(examen.pourcent) < 80 ? 'red' : 'green') : 'inherit' }}
                                                                            >
                                                                                {examen.total_questions && examen.nombre_correct && examen.pourcent ?
                                                                                    `${examen.nombre_correct}/${examen.total_questions} (${examen.pourcent ? examen.pourcent + '%' : ''})`
                                                                                    : ' '
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })
                                                            ) : (
                                                                <div className="mt-3 d-flex justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
                                                                    <span
                                                                        className="spinner-border spinner-border-lg text-success"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                        style={{ width: '3rem', height: '3rem' }}
                                                                    ></span>
                                                                </div>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            {/* Pagination Controls */}
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                {/* <div className="dataTables_info" role="status" aria-live="polite">
                                                    {`Élément ${indexOfFirstExamen + 1} à ${Math.min(indexOfLastExamen, totalItems)} sur ${totalItems}`}
                                                </div> */}
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstExamen + 1} à ${Math.min(indexOfLastExamen, totalItems)} sur ${totalItems}`}
                                                </div>

                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5; // Nombre total de pages à afficher
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        // Ajuster le startPage si la fin dépasse le total des pages
                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        // Ajout des boutons de pages
                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    {/* Bouton pour aller à la dernière page */}
                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Historique_examen;
